import React, { useState } from "react";
import { Button, Input } from "antd";

import AudienceIdentificationFilter from "./AudienceIdentificationFilter";
import AudiencePatientHistoryFilter from "./AudiencePatientHistoryFilter";
import AudienceOralHealthFilter from "./AudienceOralHealthFilter";
import AudienceInsuranceFilter from "./AudienceInsuranceFilter";
import AudienceLocationFilter from "./AudienceLocationFilter";
import AudiencePaymentFilter from "./AudiencePaymentFilter";
import AudienceFilterItem from "./AudienceFilterItem";

import arrowLeft from "../../../assets/icons/arrow-left.svg";
import filter from "../../../assets/icons/filter.svg";

export default function CreateAudienceFilterList({
  setCreateAudienceStep,
  showAudienceModal,
  setAudienceName,
  audienceName,
  // location
  setLocationFilter,
  locationFilter,
  // Oral Health
  setOralHealthFilter,
  oralHealthFilter,
  // Identification
  setIdentificationFilter,
  identificationFilter,
  // Patient history
  setPatientHistoryFilter,
  patientHistoryFilter,
  // Insurance
  setInsuranceFilter,
  insuranceFilter,
  // payment
  setPaymentFilter,
  paymentFilter,
}) {
  const [createdInsuranceFilters, setCreatedInsuranceFilters] = useState([]);
  const [newInsurance, setNewInsurance] = useState({
    insurance_category: "",
    insurance_coverage: "",
    coverage_types: "",
  });

  const [createdPatientHistories, setCreatedPatientHistories] = useState([]);
  const [newPatientHistory, setNewPatientHistory] = useState({
    integer_value: undefined,
    date_range: { lower: "", upper: "" },
  });

  const [location, setLocation] = useState("");
  const [showFilters, setShowFilters] = useState(true);

  return (
    <div style={{ marginTop: 30 }}>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 25 }}>
        <p style={{ marginBottom: 0, fontSize: 17, textTransform: "capitalize" }}>{showAudienceModal.type} Audience</p>

        <Button
          style={{ display: "flex", alignItems: "center", justifyContent: "space-between", color: "#6b43B5", border: "1px solid #6B43B5" }}
          onClick={() => setCreateAudienceStep("1")}
        >
          <img src={arrowLeft} alt="left arrow" />
          Back
        </Button>
      </div>

      <div style={{ display: "flex", flexDirection: "column", alignItems: "start", gap: 10, marginBottom: 25 }}>
        <span style={{ fontSize: 16 }}>Audience Name</span>
        <Input
          type="text"
          placeholder="Enter Audience Name"
          style={{ borderRadius: 7, border: "1px solid #6B43B5", width: "100%" }}
          onChange={(e) => setAudienceName(e.target.value)}
        />
      </div>

      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          marginBottom: 25,
          cursor: "pointer",
        }}
        onClick={() => setShowFilters((show) => !show)}
      >
        <span style={{ fontSize: 16 }}>Audience Filter</span>
        <img src={filter} alt="filter" style={{ transform: `rotate(${showFilters ? "0" : "180deg"})` }} />
      </div>

      <p style={{ fontSize: 14, color: "#979797", marginBottom: 25 }}>By Expand every item below you can add filters to your audience group.</p>

      {showFilters && (
        <div style={{ display: "flex", flexDirection: "column", gap: 20 }}>
          {/* Identification */}
          <AudienceFilterItem
            identificationFilter={identificationFilter}
            setIdentificationFilter={setIdentificationFilter}
            filterName="Identification"
            description="Such as First name, Last name, Birth date, Gender, Age"
          >
            <AudienceIdentificationFilter identificationFilter={identificationFilter} setIdentificationFilter={setIdentificationFilter} />
          </AudienceFilterItem>

          {/* Location */}
          <AudienceFilterItem
            locationFilter={locationFilter}
            setLocationFilter={setLocationFilter}
            setLocation={setLocation}
            filterName="Location"
            description="Such as Country, City, ZIP Code, Address"
          >
            <AudienceLocationFilter setLocationFilter={setLocationFilter} audienceName={audienceName} location={location} setLocation={setLocation} />
          </AudienceFilterItem>

          {/* Patient History */}
          <AudienceFilterItem
            patientHistoryFilter={patientHistoryFilter}
            setPatientHistoryFilter={setPatientHistoryFilter}
            filterName="Patient History"
            description="Such as Treatment Plans, Procedure Codes, Date of Actions"
          >
            <AudiencePatientHistoryFilter
              createdPatientHistories={createdPatientHistories}
              setCreatedPatientHistories={setCreatedPatientHistories}
              newPatientHistory={newPatientHistory}
              setNewPatientHistory={setNewPatientHistory}
              setPatientHistoryFilter={setPatientHistoryFilter}
              patientHistoryFilter={patientHistoryFilter}
            />
          </AudienceFilterItem>

          {/* Insurance */}
          <AudienceFilterItem
            insuranceFilter={insuranceFilter}
            setInsuranceFilter={setInsuranceFilter}
            filterName="Insurance"
            description="Such as Services, Insurance Company, Insurance Coverage"
          >
            <AudienceInsuranceFilter
              setInsuranceFilter={setInsuranceFilter}
              insuranceFilter={insuranceFilter}
              createdInsuranceFilters={createdInsuranceFilters}
              setCreatedInsuranceFilters={setCreatedInsuranceFilters}
              newInsurance={newInsurance}
              setNewInsurance={setNewInsurance}
            />
          </AudienceFilterItem>

          {/* Payment */}
          <AudienceFilterItem
            paymentFilter={paymentFilter}
            setPaymentFilter={setPaymentFilter}
            filterName="Payment"
            description="Such as Payment method, Payment Plan Created date, Payment Plan Amount"
          >
            <AudiencePaymentFilter setPaymentFilter={setPaymentFilter} paymentFilter={paymentFilter} />
          </AudienceFilterItem>

          {/* Oral Health */}
          <AudienceFilterItem
            oralHealthFilter={oralHealthFilter}
            setOralHealthFilter={setOralHealthFilter}
            filterName="Oral Health"
            description="Such as Occlusion score, Preventive Care score, Oral Health Score"
          >
            <AudienceOralHealthFilter setOralHealthFilter={setOralHealthFilter} oralHealthFilter={oralHealthFilter} />
          </AudienceFilterItem>
        </div>
      )}
    </div>
  );
}
